export default "__VITE_ASSET__be4e9982__"